import { CTAType } from '@/types/other';

export default async function getCtaCount(): Promise<CTAType | null> {
  try {
    const respose = await fetch('/api/get-cta-count');
    if (!respose.ok) {
      throw new Error('Error fetching cta count');
    }
    const ctaCount = await respose.json();
    return ctaCount;
  } catch (e) {
    return {
      buyerNotificationsCallToAc: 0,
      sellerNotificationsCallToAc: 0,
      totalNotificationsCallToAc: 0,
    };
  }
}
